<ng-select #ngCategory [items]="companyCategoryService.SubCategories$ | async" bindLabel="subCategoryName"
bindValue="subCategoryName" [formControl]="control" [placeholder]="'Select an option'">
</ng-select>
<app-form-errors [control]="control" fieldName="Sub Category"></app-form-errors>